import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { landing } from "../constants/constants";
import RotatingText from "../components/common/rotatingText/RotatingText";

function Landing() {
  return (
    <Container fluid className="px-0 landing-section">
      <Row className="main-content-landing">
        <Col lg="6" className="h-100">
          <div className="h-100 overflow-hidden">
            <div className="color-block"></div>
            <div
              className="profile-div"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <img className="profile-pic" src="/assets/dp.png" alt="profile" />
            </div>
          </div>
        </Col>
        <Col
          lg="6"
          className="mb-lg-0 mb-5 h-100 d-flex align-items-center justify-content-lg-center justify-content-center"
        >
          <div
            className="text-white landing-texts position-relative"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <div className="hyphen">
              <h1 className="bolder primary-color large-heading text-center-before-lg fw-bolder">
                I'M {landing.name}.
              </h1>
              <div>
                <RotatingText
                  texts={landing.title}
                  mainClassName="overflow-hidden py-0.5 sm:py-1 md:py-2"
                  elementLevelClassName="primary-color bolder large-heading fw-bolder"
                  staggerFrom={"last"}
                  initial={{ y: "100%" }}
                  animate={{ y: 0 }}
                  exit={{ y: "-120%" }}
                  staggerDuration={0.025}
                  splitLevelClassName="overflow-hidden pb-0.5 sm:pb-1 md:pb-1"
                  transition={{ type: "spring", damping: 30, stiffness: 400 }}
                  rotationInterval={3000}
                />
              </div>
            </div>

            {landing.intro}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Landing;
